export enum ELolCategory {
  RANKED = "ranked",
  NORMAL = "normal",
  HANDLEVEL = "handlevel",
}
